import React from "react"
import FutureDevelopment from "../../components/pages/development/future-developments"

const FutureDevelopmentPage = (props) => <FutureDevelopment {...props} />

export default FutureDevelopmentPage